import React from 'react'
import NavigationBar from '../Commons/NavigationBar'
import CreateGroupForm from './GroupForm'
import { getToken } from '../Commons/Authentication'
import { ToastContainer, ToastMessage } from 'react-toastr'
import * as request from 'superagent'
import NoCache from 'superagent-no-cache'
import { hashHistory } from 'react-router'
import _ from 'lodash'
import moment from 'moment'

export default class GroupComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = ({ group: '', isUpdate: false })
  }

  componentWillMount () {
    if (!_.isEmpty(this.props.params)) {
      console.log(this.props.params)
      this.setState({ group: this.props.params.group, isUpdate: true })
    }
  }

  render () {
    document.title = 'Registrar Grupos - CORE 3.0'
    return (
      <div className='main-information-container'>
        <NavigationBar/>
        <div className='registration-container-group'>
          <div className='group-profile'>
            <CreateGroupForm groupName={this.state.group} isUpdate={this.state.isUpdate} />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Group/GroupComponent.js